import React, { useState } from 'react';
import { IGroup } from '../../api/groups';
import Popup from '../../components/Popup';
import { INewsItem, uploadNewsMedia, useNewsCreate, useNewsDelete, useNewsUpdate } from '../../api/news';
import { NewsMedia } from './MediaDetails';
import { IAdSchedule } from '../../api/ads';
import NewsOverview from './NewsOverview'
import TabsPanel from '../../components/Tabs';
import Schedule from '../../components/Schedule';

const initFilesToUpload = { video: null, image: null, feedImage: null };

let filesToUpload = { video: null, image: null, feedImage: null };

export type InputType = React.ChangeEvent<HTMLInputElement>;

type NewsMediaField = 'video' | 'image' | 'feedImage';

interface IProps {
    item: INewsItem;
    onSave: any;
    onClose: any;
    groups: IGroup[];
}

export default function NewsDetails({ item, groups, onSave, onClose }: IProps) {
    const useSave = item.id ? useNewsUpdate : useNewsCreate;

    const [uploading, setUploading] = useState(false);

    const [save, saving] = useSave(async (res: any) => {
        if (res.success) {
            if ((['image', 'feedImage', 'video'] as NewsMediaField[]).some((i) => filesToUpload[i])) {
                setUploading(true);

                await uploadNewsMedia(filesToUpload, { ...item, id: res.data.id });

                filesToUpload = initFilesToUpload;
                setUploading(false);
            }

            onSave();
            if (!item.id) {
                onClose();
            }
        }
    });

    const [remove, removing] = useNewsDelete((res: any) => {
        if (res.success) {
            onSave();
            onClose();
        }
    });

    const initial = {
        ...item,
        groups: item.groups?.map((g) => g.id),
    };

    const onChangeMediaInput = (type: NewsMediaField) => {
        return (file: any) => Object.assign(filesToUpload, { [type]: file });
    };

    const tabs = [
        {
            title: 'Информация',
            content: <NewsOverview
                item={item}
                groups={groups}
                save={save}
                saving={saving}
                remove={remove}
                removing={removing}
            />
        },
        {
            title: 'Медиа файлы',
            content: <NewsMedia item={item}
                groups={groups}
                save={save}
                saving={saving}
                uploading={uploading}
                remove={remove}
                removing={removing}
                onChangeMediaInput={onChangeMediaInput} />,
            disabled: !item.id,
        },
        {
            title: 'Расписание',
            content: <Schedule
                schedule={item.schedule}
                save={(schedule: IAdSchedule) => save({ ...item, schedule })}
                saving={saving}
            />,
            disabled: !item.id,
        }
    ]

    return (
        <Popup onClose={onClose} width={600} title={item.name || 'Добавление новости'}>
            <TabsPanel tabs={tabs} />
        </Popup>
    )
}
